export default {
  use_app(state) {
    return state.use_app
  }
}
